<!--
 * @作者: kerwin
 * @公众号: 大前端私房菜
-->
<template>
    <el-empty description="404 走丢了" />
</template>
